import React from 'react';
import { Grid, Card, CardContent, Typography, Divider } from '@mui/material';


const AccountsSummary = ( {data} ) => {

  return (
    <>
      <Grid container spacing={3}>
        {/* Table Card */}
        <Grid item xs={12}>
          <Card style={{ height: '260px' }}>
            <CardContent>
               <div style={{ overflow: 'auto', height: '200px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid #ddd' }}>
                      <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Account ID</th>
                      <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Account Name</th>
                      <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Forecasted Cost ($)</th>
                      <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Potential Cost Savings ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    { data && data.length>0 && data.map((account, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
                        <td style={{ padding: '8px', textAlign: 'left' }}>{account.accountId}</td>
                        <td style={{ padding: '8px', textAlign: 'left' }}>{account.accountName}</td>
                        <td style={{ padding: '8px', textAlign: 'left' }}>
                          {account.forecastedCost ? account.forecastedCost.toFixed(2) : '0.00'}
                        </td>
                        <td style={{ padding: '8px', textAlign: 'left' }}>
                          {account.totalPotentialSavings ? account.totalPotentialSavings.toFixed(2) : '0.00'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardContent>
          </Card>
        </Grid>       
      </Grid>

    </>
  );
};

export default AccountsSummary;
